import type { ISubmitBidApplicationParams } from '../clients/SubmitBidApplication';
import * as Client from '../clients/SubmitBidApplication';

export const submitBidApplicationService = async (
  params: ISubmitBidApplicationParams,
): Promise<void> => {
  await Client.submitBidApplication(params);
};
